import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";

@Component({
  selector: "app-market-cap-filter",
  templateUrl: "./market-cap-filter.component.html",
  styleUrls: ["./market-cap-filter.component.scss"],
})
export class MarketCapFilterComponent {
  @Input() selectedMarketCaps: Array<number> = [-1];
  @Input() marketCapData: Array<any> = [
    {
      title: "All Market Cap",
      key: -1,
      selected: true,
      children: [
        {
          title: "Large: >$10B",
          key: 1,
          isLeaf: true,
          selected: true,
        },
        {
          title: "Mid: $2B-$10B",
          key: 2,
          isLeaf: true,
          selected: true,
        },
        {
          title: "Small: <$2B",
          key: 3,
          isLeaf: true,
          selected: true,
        },
      ],
    },
  ];
  @Output() onMarketCapSelect: EventEmitter<Array<number>> = new EventEmitter();
  @Input() marketCapExpandedKeys: Array<number>;
  @Input() isLoading: boolean;
  @Input() defaultCheckedKeys = [];
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 4,
      },
    },
  };

  ngOnChanges() {
    if (this.marketCapData && this.marketCapData.length > 0) {
      this.marketCapData[0]["expanded"] = true;
    }
  }

  onCheckboxChange(data) {
    this.onMarketCapSelect.emit(data.keys);
  }
}
